import React, { Fragment } from 'react';
import SignatureImage from '../../images/signarure-img.jpeg';
import Signature2 from '../../images/signature-2.jpeg';

const MOUSignatures = ({ data }) => {
  const submittedDate = data.submittedAt
    ? new Date(data.submittedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
    : 'No date available';

  return (
    <Fragment>
      <div className="agreement-2024" style={{padding: '40px 0'}}>
        <h2 style={{paddingLeft: '41pt', textIndent: '0pt', lineHeight: '112%', textAlign: 'left'}}>
          In Witness Whereof, <span className="p">the Parties have executed this Agreement as of the dates associated with the signatures below.</span>
        </h2>

        <div style={{marginTop: '60px', paddingLeft: '41pt', paddingRight: '41pt'}}>
          {/* First Signature Row */}
          <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '60px'}}>
            <div style={{width: '48%'}}>
              <div style={{borderBottom: '2px solid #000', paddingBottom: '10px', marginBottom: '10px', minHeight: '60px', display: 'flex', alignItems: 'flex-end'}}>
                <img src={Signature2} alt="Signature" style={{height: '50px', width: 'auto'}} className="signature-print-only" />
              </div>
              <p style={{margin: '0', fontWeight: 'bold', fontSize: '14px'}}>HFB Signature (Senior Manager of Educational Services)</p>
            </div>
            <div style={{width: '48%'}}>
              <div style={{borderBottom: '2px solid #000', paddingBottom: '10px', marginBottom: '10px', minHeight: '60px', display: 'flex', alignItems: 'flex-end'}}>
                <p style={{margin: '0', fontSize: '14px'}}>{submittedDate}</p>
              </div>
              <p style={{margin: '0', fontWeight: 'bold', fontSize: '14px'}}>Date</p>
            </div>
          </div>

          {/* Second Signature Row */}
          <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '60px'}}>
            <div style={{width: '48%'}}>
              <div style={{borderBottom: '2px solid #000', paddingBottom: '10px', marginBottom: '10px', minHeight: '60px', display: 'flex', alignItems: 'flex-end'}}>
                <img src={SignatureImage} alt="Signature" style={{height: '50px', width: 'auto'}} className="signature-print-only" />
              </div>
              <p style={{margin: '0', fontWeight: 'bold', fontSize: '14px'}}>HFB Signature (HFB President and CEO)</p>
            </div>
            <div style={{width: '48%'}}>
              <div style={{borderBottom: '2px solid #000', paddingBottom: '10px', marginBottom: '10px', minHeight: '60px', display: 'flex', alignItems: 'flex-end'}}>
                <p style={{margin: '0', fontSize: '14px'}}>{submittedDate}</p>
              </div>
              <p style={{margin: '0', fontWeight: 'bold', fontSize: '14px'}}>Date</p>
            </div>
          </div>

          {/* Partner Signature Row */}
          <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '40px'}}>
            <div style={{width: '48%'}}>
              <div style={{borderBottom: '2px solid #000', paddingBottom: '10px', marginBottom: '10px', minHeight: '60px', display: 'flex', alignItems: 'flex-end'}}>
                {data.school && data.school.principal && (
                  <p style={{margin: '0', fontSize: '14px', fontStyle: 'italic'}}>{data.school.principal.firstName} {data.school.principal.lastName}</p>
                )}
              </div>
              <p style={{margin: '0', fontWeight: 'bold', fontSize: '14px'}}>Partner Signature</p>
            </div>
            <div style={{width: '48%'}}>
              <div style={{borderBottom: '2px solid #000', paddingBottom: '10px', marginBottom: '10px', minHeight: '60px', display: 'flex', alignItems: 'flex-end'}}>
                {data.signedAt && (
                  <p style={{margin: '0', fontSize: '14px'}}>{new Date(data.signedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
                )}
              </div>
              <p style={{margin: '0', fontWeight: 'bold', fontSize: '14px'}}>Date</p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default MOUSignatures;
